import React from 'react'
import SaveIcon from 'client/utils/icons/save-icon'
import {
  DcButton,
  DcDiv,
  DcInput,
  DcText,
  PixelFactoryContext,
  PixelFlexBox,
} from 'pixel-base'

import { changePasswordAPI } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

const ChangePassword = (props: {
  user: { id: string }
  handleClose: () => void
}) => {
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const { user, handleClose } = props
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [data, setData] = React.useState({
    password: '',
    confirm_password: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    handleChangePassword()
  }

  const handleChangePassword = () => {
    showPageLoader()
    changePasswordAPI(data, user.id).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Successfully Added')
        handleClose()
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
      }
    })
  }

  return (
    <>
      <form
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
        onSubmit={handleSubmit}
      >
        <PixelFlexBox
          flexDirection="row"
          justifyContent="flex-start"
          gap="10px"
          width="100%"
          style={{ flexGrow: 1 }}
        >
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Password
            </DcText>
            <DcInput
              error={
                error.field === 'name' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'password'}
              name={'password'}
              placeholder={'Enter your new password'}
              value={data.password}
              onChange={(e) => setData({ ...data, password: e.target.value })}
            />
          </DcDiv>
        </PixelFlexBox>
        <PixelFlexBox
          flexDirection="row"
          justifyContent="flex-start"
          gap="10px"
          width="100%"
          style={{ flexGrow: 1 }}
        >
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Confirm Password
            </DcText>
            <DcInput
              error={
                (error.field === 'confirm_password' && error.error !== ''
                  ? error.error
                  : null) ||
                (data.confirm_password &&
                data.confirm_password !== data.password
                  ? 'password does not match.'
                  : null)
              }
              required
              type={'password'}
              name={'cpassword'}
              placeholder={'Confirm your new password'}
              value={data.confirm_password}
              onChange={(e) =>
                setData({ ...data, confirm_password: e.target.value })
              }
            />
          </DcDiv>
        </PixelFlexBox>

        <PixelFlexBox
          flexDirection="row"
          justifyContent="flex-end"
          gap="10px"
          width="100%"
          style={{ flexGrow: 1 }}
        >
          <DcButton variant="primary" type="submit" withIcon={true} size="sm">
            <SaveIcon size={16} />
            <span>Save</span>
          </DcButton>
        </PixelFlexBox>
      </form>
    </>
  )
}

export default ChangePassword
